import { Box, LinearProgress, Typography } from '@mui/material';
import { LocalSeoAllSx } from './localSeoCss';
import { localSeoTexts } from './localSeoTexts';

export const LocalSeoProgress = ({
  completedCount,
  totalCount,
  countProgress
}) => {
  return (
    <>
      <Typography sx={LocalSeoAllSx?.localSeoTaskProgressCountText}>
        <b>{completedCount}</b> of <b>{totalCount}</b>{' '}
        {localSeoTexts?.tasksCompleted}
      </Typography>
      <Box sx={{ display: 'flex' }}>
        <LinearProgress
          variant="determinate"
          value={countProgress}
          sx={LocalSeoAllSx?.localSeoProgressSx}
          color={'secondary'}
        />
      </Box>
    </>
  );
};
